import _ from '@lodash';
import { AppBar, DialogActions, DialogContent, IconButton, TextField, Toolbar, Typography } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/ChaveActions';

const md = new MobileDetect(window.navigator.userAgent);

const newChaveState = {
    tipo: null,
    idchave: null,
    idpessoa: null,
    destinatario: null,
    remetente: null,
    codigo: null,
    formulario: {},
    descricao: null,
    validade: null,
    validadedescricao: null,
    statusregistro: null,
};

class ChaveDialog extends XAPPComponent {

    state = {
        ...newChaveState,
        tipo: this.props.tipo
    };

    componentDidUpdate(prevProps, prevState) {

        if (this.props.Chave.error) {
            this.props.showMessage({
                message: this.props.Chave.error,
                variant: 'error'
            });
            this.props.Chave.error = null;
        }
        if (this.props.Chave.warning) {
            this.props.showMessage({
                message: this.props.Chave.warning,
                variant: 'warning'
            });
            this.props.Chave.warning = null;
        }
        if (this.props.Chave.info) {
            this.props.showMessage({
                message: this.props.Chave.info,
                variant: 'success'
            });
            this.props.Chave.info = null;
            this.props.openDialog();
        }

        if (!_.isNull(this.props.Chave.dialog) && !_.isEqual(prevProps.Chave.dialog, this.props.Chave.dialog)) {
            this.setState(Object.assign({}, this.props.Chave.dialog));
        }

        if (_.isNull(this.props.Chave.dialog) && !_.isEqual(prevProps.Chave.dialog, this.props.Chave.dialog)) {
            this.setState(Object.assign({}, newChaveState, { tipo: this.props.tipo }));
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    };

    canBeSubmitted = () => {
        const { validade } = this.state;

        return (
            validade !== null && validade !== ""
        );
    }

    render() {
        const { save, xappRouteParams, Chave, openDialog } = this.props;
        const form = this.state;
        return (
            <XAPPDialog
                id="Chave"
                open={!_.isNull(Chave.dialog)}
                onClose={() => openDialog()}
                fullWidth
                fullScreen={md.mobile() !== null}
                maxWidth={md.mobile() === null && md.tablet() === null && "sm"}
            >

                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {_.isNull(form.idchave) ? "Novo chave" : "Editar chave"}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog()}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent className="p-20">
                    {!_.isNull(form.idchave) &&
                        <TextField
                            className="mb-12 w-full"
                            label="Código"
                            id="codigo"
                            name="codigo"
                            value={form.codigo}
                            onChange={this.handleChange}
                            disabled
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    }
                    <TextField
                        className="mb-12 w-full"
                        label="Validade"
                        id="validade"
                        name="validade"
                        value={form.validade}
                        onChange={this.handleChange}
                        variant="outlined"
                        fullWidth
                        type="datetime-local"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        className="mb-12 w-full"
                        label="Login"
                        id="login"
                        name="login"
                        value={form.login}
                        onChange={this.handleChange}
                        variant="outlined"
                        disabled={!_.isNull(form.idchave)}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    {!_.isNull(form.idchave) && !_.isNull(form.remetentedados) &&
                        <TextField
                            className="mb-12 w-full"
                            label="Remetente"
                            id="remetentenome"
                            name="remetentenome"
                            value={form.remetentedados.nome}
                            disabled
                            variant="outlined"
                            fullWidth
                        />
                    }
                    {!_.isNull(form.idchave) && !_.isNull(form.destinatariodados) &&
                        <TextField
                            className="mb-12 w-full"
                            label="Destinatário"
                            id="destinatarionome"
                            name="destinatarionome"
                            value={form.destinatariodados.nome}
                            disabled
                            variant="outlined"
                            fullWidth
                        />
                    }
                    <TextField
                        className="w-full"
                        label="Descrição"
                        id="descricao"
                        name="descricao"
                        value={form.descricao}
                        onChange={this.handleChange}
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={3}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0 px-8">
                        <DialogActions>

                            {!_.isNull(form.idchave) && form.status !== 1 &&
                                <XAPPButton
                                    type="Button"
                                    className="bg-grey-darker hover:bg-grey-darker text-white mr-8"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => save(form, xappRouteParams, 'INATIVARCHAVE')}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"block"}
                                    label={md.mobile() === null && md.tablet() === null ? (form.statusregistro === 0 ? 'Ativar' : 'Inativar') : ''}
                                />
                            }

                            {!_.isNull(form.idchave) && form.status === 1 &&
                                <XAPPButton
                                    type="Button"
                                    className="bg-red hover:bg-red text-white mr-8"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => save({ ...form, status: -1 }, xappRouteParams, 'ALTERARSTATUSCHAVE')}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"block"}
                                    label={md.mobile() === null && md.tablet() === null ? (form.statusregistro === 0 ? 'Ativar' : 'Inativar') : ''}
                                />
                            }
                            <XAPPButton
                                type="Button"
                                className="bg-green hover:bg-green text-white mr-8"
                                variant="contained"
                                color="primary"
                                onClick={() => save(form, xappRouteParams, 'INSERIRCHAVE')}
                                disabled={!this.canBeSubmitted()}
                                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                icon={"save"}
                                label={md.mobile() === null && md.tablet() === null ? 'Salvar' : ''}
                            />
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: Actions.openDialog,
        save: Actions.save,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ Chave }) {
    return {
        Chave: Chave,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChaveDialog);
